import { GeneralInfoEditCameraTab } from "../GeneralInfoEditCameraTab";
import { ConnectionsTab } from "../ConnectionsTab";
import { NotificationsTab } from "../NotificationsTab";
import { ProductsTab } from "../ProductsTab";
import { Dispatcher } from "../../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { NavigateFunction } from "react-router-dom";
import { AxisTab } from "../AxisTab";
import { MobotixTab } from "../MobotixTab";
import ErrorBoundary from "../../../../ErrorBoundary";
import { StreamParametersTab } from "../StreamParametersTab";
import { AlertSettingsTab } from "../AlertSettingsTab";
import { useEditCameraStore } from "../editCameraStore/editCameraStore";
import { SlicingTab } from "../SlicingTab";
import { VlmTab } from "../VlmTab";

export const handleEditCameraCancelButtonClick = (
  setEditMode: any,
  clickedTab: any,
  setActiveTab: any,
  siteInfo: any,
  cameraGeneralInfo: any,
  setCameraGeneralInfo: any,
  cameraGeneralInfoBackup: any,
  setPatchObject: any,
  immixAlerts: any,
  diceAlerts: any,
  sureviewAlerts: any,
  setAddImmixAlertDialogOpen: any,
  setAddDiceAlertDialogOpen: any,
  setAddSureviewAlertDialogOpen: any,
  activeProducts: any,
  setBackdropLoadingScreenOn: any,
  setSendingImmixTest: Dispatcher<boolean>,
  setImmixTestSuccessDialogOpen: Dispatcher<boolean>,
  setImmixTestFailDialogOpen: Dispatcher<boolean>,
  setSendingDiceTest: Dispatcher<boolean>,
  setDiceTestSuccessDialogOpen: Dispatcher<boolean>,
  setDiceTestFailDialogOpen: Dispatcher<boolean>,
  recipientsConfiguredData: any,
  titlesArray: any,
  setRecipientsConfiguredData: any,
  setTitlesArray: any,
  actionRulesData: any,
  setActionRulesData: any,
  actionRulesTitlesArray: any,
  setActionRulesTitlesArray: any,
  applicationsConfiguredData: any,
  axisFinished: any,
  timeTablesData: any,
  setTimeTablesData: any,
  iPNotifyData: any,
  setIPNotifyData: any,
  actionHandlerData: any,
  setActionHandlerData: any,
  cameraWebhookData: any,
  productsData: any,
  setProductsData: Dispatcher<any>,
  allTabsOpen: boolean,
  setAllTabsOpen: Dispatcher<boolean>,
  backupProductsData: any,
  setBackupProductsData: any,
  sentinelAlerts: any,
  setAddSentinelAlertDialogOpen: any,
  boldAlerts: any,
  setAddBoldAlertDialogOpen: Dispatcher<boolean>,
  patriotAlerts: any,
  setAddPatriotAlertDialogOpen: Dispatcher<boolean>,
  uSMonitoringAlerts: any,
  setAddUSMonitoringAlertDialogOpen: Dispatcher<boolean>,
  softguardAlerts: any,
  setAddSoftguardAlertDialogOpen: Dispatcher<boolean>,
  streamParametersData: any,
  setAddStreamWebhookDialogOpen: Dispatcher<boolean>,
  setEditStreamWebhookDialogOpen: Dispatcher<boolean>,
  setDeleteImmixAlertDialogOpen: Dispatcher<boolean>,
  setDeleteDiceAlertDialogOpen: Dispatcher<boolean>,
  immixAlertsOnCamera: boolean,
  diceAlertsOnCamera: boolean,
  sureViewAlertsOnCamera: boolean,
  webhooksAlertsOnCamera: boolean,
  sentinelAlertsOnCamera: boolean,
  boldAlertsOnCamera: boolean,
  patriotAlertsOnCamera: boolean,
  softguardAlertsOnCamera: boolean,
  evalinkAlertsOnCamera: boolean,
  navigate: NavigateFunction
) => {
  const { setUpdatedAlertStreams, setUpdatedAlertStreamTypes } =
    useEditCameraStore.getState();
  setProductsData(backupProductsData);
  setEditMode(false);
  setCameraGeneralInfo(cameraGeneralInfoBackup);
  setPatchObject({
    camera_name: cameraGeneralInfoBackup.camera_name,
    streams: cameraGeneralInfoBackup.streams,
  });
  setUpdatedAlertStreams({
    immix: {},
    dice: {},
    sureview: {},
    sentinel: {},
    bold: {},
    patriot: {},
    softguard: {},
    sysaid: {},
    evalink: {},
  });
  setUpdatedAlertStreamTypes({
    immix: false,
    dice: false,
    sureview: false,
    sentinel: false,
    bold: false,
    patriot: false,
    softguard: false,
    sysaid: false,
    evalink: false,
  });
  if (clickedTab === "one") {
    setActiveTab(
      <ErrorBoundary>
        <GeneralInfoEditCameraTab
          siteInfo={siteInfo}
          cameraGeneralInfo={cameraGeneralInfoBackup}
        />
      </ErrorBoundary>
    );
  } else if (clickedTab === "two") {
    setActiveTab(
      <ErrorBoundary>
        <ConnectionsTab cameraGeneralInfo={cameraGeneralInfoBackup} />
      </ErrorBoundary>
    );
  } else if (clickedTab === "three") {
    setActiveTab(
      <ErrorBoundary>
        <NotificationsTab cameraGeneralInfo={cameraGeneralInfoBackup} />
      </ErrorBoundary>
    );
  } else if (clickedTab === "four") {
    setProductsData(backupProductsData);
    setActiveTab(
      <ErrorBoundary>
        <ProductsTab
          productsData={backupProductsData}
          setProductsData={setProductsData}
          allTabsOpen={allTabsOpen}
          setAllTabsOpen={setAllTabsOpen}
          setBackupProductsData={setBackupProductsData}
        />
      </ErrorBoundary>
    );
  } else if (clickedTab === "seven") {
    setActiveTab(
      <ErrorBoundary>
        <AxisTab
          recipientsConfiguredData={recipientsConfiguredData}
          titlesArray={titlesArray}
          navigate={navigate}
          setBackdropLoadingScreenOn={setBackdropLoadingScreenOn}
          setRecipientsConfiguredData={setRecipientsConfiguredData}
          setTitlesArray={setTitlesArray}
          actionRulesData={actionRulesData}
          setActionRulesData={setActionRulesData}
          actionRulesTitlesArray={actionRulesTitlesArray}
          setActionRulesTitlesArray={setActionRulesTitlesArray}
          setActiveTab={setActiveTab}
          applicationsConfiguredData={applicationsConfiguredData}
          cameraGeneralInfo={cameraGeneralInfo}
          axisFinished={axisFinished}
        />
      </ErrorBoundary>
    );
  } else if (clickedTab === "eight") {
    setActiveTab(
      <ErrorBoundary>
        <MobotixTab
          timeTablesData={timeTablesData}
          navigate={navigate}
          setBackdropLoadingScreenOn={setBackdropLoadingScreenOn}
          setTimeTablesData={setTimeTablesData}
          setActiveTab={setActiveTab}
          iPNotifyData={iPNotifyData}
          setIPNotifyData={setIPNotifyData}
          actionHandlerData={actionHandlerData}
          setActionHandlerData={setActionHandlerData}
        />
      </ErrorBoundary>
    );
  } else if (clickedTab === "fifteen") {
    setActiveTab(
      <ErrorBoundary>
        <StreamParametersTab streamParametersData={streamParametersData} />
      </ErrorBoundary>
    );
  } else if (clickedTab === "sixteen") {
    setActiveTab(
      <ErrorBoundary>
        <AlertSettingsTab
          immixAlerts={immixAlerts}
          setAddImmixAlertDialogOpen={setAddImmixAlertDialogOpen}
          setSendingImmixTest={setSendingImmixTest}
          setImmixTestSuccessDialogOpen={setImmixTestSuccessDialogOpen}
          setImmixTestFailDialogOpen={setImmixTestFailDialogOpen}
          setDeleteImmixAlertDialogOpen={setDeleteImmixAlertDialogOpen}
          diceAlerts={diceAlerts}
          setAddDiceAlertDialogOpen={setAddDiceAlertDialogOpen}
          setSendingDiceTest={setSendingDiceTest}
          setDiceTestSuccessDialogOpen={setDiceTestSuccessDialogOpen}
          setDiceTestFailDialogOpen={setDiceTestFailDialogOpen}
          setDeleteDiceAlertDialogOpen={setDeleteDiceAlertDialogOpen}
          sureviewAlerts={sureviewAlerts}
          setAddSureviewAlertDialogOpen={setAddSureviewAlertDialogOpen}
          setAddStreamWebhookDialogOpen={setAddStreamWebhookDialogOpen}
          setEditStreamWebhookDialogOpen={setEditStreamWebhookDialogOpen}
          sentinelAlerts={sentinelAlerts}
          setAddSentinelAlertDialogOpen={setAddSentinelAlertDialogOpen}
          boldAlerts={boldAlerts}
          setAddBoldAlertDialogOpen={setAddBoldAlertDialogOpen}
          patriotAlerts={patriotAlerts}
          setAddPatriotAlertDialogOpen={setAddPatriotAlertDialogOpen}
          softguardAlerts={softguardAlerts}
          setAddSoftguardAlertDialogOpen={setAddSoftguardAlertDialogOpen}
          immixAlertsOnCamera={immixAlertsOnCamera}
          diceAlertsOnCamera={diceAlertsOnCamera}
          sureViewAlertsOnCamera={sureViewAlertsOnCamera}
          siteInfo={siteInfo}
          webhooksAlertsOnCamera={webhooksAlertsOnCamera}
          sentinelAlertsOnCamera={sentinelAlertsOnCamera}
          boldAlertsOnCamera={boldAlertsOnCamera}
          patriotAlertsOnCamera={patriotAlertsOnCamera}
          softguardAlertsOnCamera={softguardAlertsOnCamera}
          evalinkAlertsOnCamera={evalinkAlertsOnCamera}
          navigate={navigate}
        />
      </ErrorBoundary>
    );
  } else if (clickedTab === "five") {
    setActiveTab(
      <ErrorBoundary>
        <SlicingTab />
      </ErrorBoundary>
    );
  } else if (clickedTab === "seventeen") {
    useEditCameraStore.getState().resetVlmDraft();
    setActiveTab(
      <ErrorBoundary>
        <VlmTab />
      </ErrorBoundary>
    );
  }
  setBackdropLoadingScreenOn(false);
};
